<div class="tie-bar-wrapper {{themeService.isDarkMode ? 'dark': 'light'}}">
    <ion-row class="row ion-text-center">

        <!-- <ion-col>
            <app-share-match [tieId]="tie._id" [position]="'change-tracker'"></app-share-match>
        </ion-col> -->

        <ion-col>
            <ion-button class="bar-button" color="gray" (click)="viewTrackers()" expand="block" fill="clear">
                <div>
                    <ion-icon name="person-add"></ion-icon>
                    <span translate>{{ 'Scorekeepers' | translate }}</span>
                </div>
            </ion-button>
        </ion-col>

        @if (isOwner || isOfficial) {
            <ion-col class="tracker-bar">
                <ion-button class="bar-button" color="gray" (click)="showMoreOptions()" expand="block" fill="clear">
                    <div>
                        <ion-icon name="apps"></ion-icon>
                        <span>{{'More' | translate}}</span>
                    </div>
                </ion-button>
            </ion-col>
        }

    </ion-row>
</div>